import React, { useState, useEffect } from 'react';
import axios from 'axios';
import EVSEChecklist from './EVSEChecklist';
import EVSEForm from './EVSEForm';
import { TARIFF_REQUIRED_FIELDS, TARIFF_FIELD_GROUPS } from '../config/tariffFields';

const API = 'https://api.cpms-srlkevcharge.com';

export default function TariffStepDetails({
  organisationMode, setOrganisationMode,
  organisationId, setOrganisationId,
  organisationName, setOrganisationName,
  selectedFields, setSelectedFields,
  formData, setFormData,
  errors,
  hideOrganisation = false
}) {
  const [organisations, setOrganisations] = useState([]);

  useEffect(() => {
    if (!hideOrganisation) {
      axios.get(`${API}/organisations/`)
        .then(res => setOrganisations(res.data))
        .catch(() => {});
    }
  }, [hideOrganisation]);

  const toggleField = (name) => {
    setSelectedFields(prev =>
      prev.includes(name) ? prev.filter(f => f !== name) : [...prev, name]
    );
    if (selectedFields.includes(name)) {
      setFormData(prev => {
        const copy = { ...prev };
        delete copy[name];
        return copy;
      });
    }
  };

  const selectAllInGroup = (names) => {
    setSelectedFields(prev => Array.from(new Set([...prev, ...names])));
  };

  const clearAllInGroup = (names) => {
    setSelectedFields(prev => prev.filter(f => !names.includes(f)));
    setFormData(prev => {
      const copy = { ...prev };
      names.forEach(n => delete copy[n]);
      return copy;
    });
  };

  const handleFieldChange = (name, value) => {
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  return (
    <>
      {/* ── Organisation Selector (hidden entirely when editing an existing tariff) ── */}
      {!hideOrganisation && (
        <div className="org-selector-card">
          <div style={{ fontSize: 13.5, fontWeight: 700, color: 'var(--navy)', marginBottom: 12 }}>
            Which organisation is this for? <span className="required">*</span>
          </div>
          <div className="org-selector-toggle">
            <button
              type="button"
              className={organisationMode === 'existing' ? 'active' : ''}
              onClick={() => setOrganisationMode('existing')}
            >
              Select Existing
            </button>
            <button
              type="button"
              className={organisationMode === 'new' ? 'active' : ''}
              onClick={() => setOrganisationMode('new')}
            >
              Create New
            </button>
          </div>

          {organisationMode === 'existing' ? (
            <select
              value={organisationId || ''}
              onChange={(e) => setOrganisationId(e.target.value)}
              style={errors.organisation ? { borderColor: 'var(--red)' } : {}}
            >
              <option value="">Select an organisation...</option>
              {organisations.map(org => (
                <option key={org.id} value={org.id}>{org.name}</option>
              ))}
            </select>
          ) : (
            <input
              type="text"
              placeholder="e.g. SRLK EV Charge Ltd"
              value={organisationName}
              onChange={(e) => setOrganisationName(e.target.value)}
              style={errors.organisation ? { borderColor: 'var(--red)' } : {}}
            />
          )}
          {errors.organisation && (
            <span className="hint" style={{ color: 'var(--red)', display: 'block', marginTop: 6 }}>
              {errors.organisation}
            </span>
          )}
        </div>
      )}

      {/* ── Tariff Checklist + Form ── */}
      <div className="evse-builder">
        <EVSEChecklist
          groups={TARIFF_FIELD_GROUPS}
          selectedFields={selectedFields}
          onToggle={toggleField}
          onSelectAllInGroup={selectAllInGroup}
          onClearAllInGroup={clearAllInGroup}
        />
        <EVSEForm
          title="Tariff Details"
          requiredFields={TARIFF_REQUIRED_FIELDS}
          groups={TARIFF_FIELD_GROUPS}
          selectedFields={selectedFields}
          formData={formData}
          onChange={handleFieldChange}
          errors={errors}
          emptyHint="Tick a box on the left to add more details about this tariff. Or leave it as is — only the fields above are required."
        />
      </div>
    </>
  );
}